import { render, staticRenderFns } from "./ReportProvinzenDeprecated.vue?vue&type=template&id=e3525d56"
import script from "./ReportProvinzenDeprecated.vue?vue&type=script&lang=js"
export * from "./ReportProvinzenDeprecated.vue?vue&type=script&lang=js"
import style0 from "./ReportProvinzenDeprecated.vue?vue&type=style&index=0&id=e3525d56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports